import * as React from "react";
const SvgTime = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#000000", width: 240, height: 240, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.25 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zM18 13h-6.75V6h2v5H18v2z" }));
export default SvgTime;
